module.exports = __webpack_public_path__ + "img/sb1.99ce4e1d.gif";